import {resourceLabel} from 'src/app/shared/resource-translations/resource-label.pipe';
import { NavigationPanelService } from 'src/app/shared/services/navigation-panel.service';
import { Component, ElementRef, ViewChild, OnDestroy, Inject, NgZone, OnInit, DOCUMENT } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/account/auth.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { LogService } from 'src/app/shared/services/log.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { environment } from 'src/environments/environment';
import { User } from '../../account/user.model';
import { ChangeDetectorRef } from '@angular/core';
import { formatNumber, Location } from '@angular/common';
import { Stack } from 'src/app/shared/services/stack.service';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';

@Component({
  selector: 'app-member-navigation',
  templateUrl: './member-navigation.component.html',
  styleUrls: ['./member-navigation.component.scss'],
  standalone: false
})
export class MemberNavigationComponent implements OnInit, OnDestroy {
  private headerResize?: ResizeObserver;
  @ViewChild('churchHeader') set churchHeader(element: ElementRef<HTMLElement> | undefined) {
    this.headerResize?.disconnect();
    if (!element) return;
    const header = element.nativeElement;
    const update = () => header.ownerDocument.documentElement.style.setProperty('--church-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    update();
    this.headerResize = new ResizeObserver(update);
    this.headerResize.observe(header);
  }

  ngOnDestroy() { this.headerResize?.disconnect(); }
  get isPersonalSignup() { return this.router.url.split(/[?#]/)[0].split('/').includes('signup'); }
  subdomain: string = '';
  isLoading: boolean = true;
  serviceUnavailable: boolean = false;
  public isStaging: boolean = false;
  public isMenuCollapsed = true;
  public userName: string = null;
  public isHomeFlag: boolean = false;
  public logoSource: string = '';
  public cmsModule: boolean = false;
  public churchName: string = null;
  get displayChurchName(){const tenant=this.globalService.simpleTenant;return resourceLabel(tenant?.name||this.churchName,tenant,'name',this.globalService.locale);}
  private churchWebsite: string = null;
  private donationLink: string = null;

  user: User;
  isDiocese: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    public panels: NavigationPanelService,
    private router: Router,
    private tenantService: TenantService,
    public globalService: GlobalService,
    private logService: LogService,
    public identityService: IdentityService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private _location: Location,
    private zone: NgZone,
    private linkHandler: LinkHandlerService,
    private overlayContainer: OverlayContainer
  ) { }

  AllowAccess(url: string) {
    if (url.indexOf('resetpassword') >= 0) return true;
    if (url.indexOf('validate') >= 0) return true;
    if (url.indexOf('formrender') >= 0) return true;
    if (url.indexOf('idcardlookup') >= 0) return true;
    if (url.indexOf('idcard') >= 0) return true;
    if (url.indexOf('fast-checkin') >= 0) return true;
    if (url.indexOf('unsubscribe') >= 0) return true;
    if (url.indexOf('qr-self-checkin') >= 0) return true;
    if (url.indexOf('qr-self-checkin-fixed') >= 0) return true;
        if (url.indexOf('qr-self-checkin-group') >= 0) return true;
            if (url.indexOf('qr-self-checkin-venue') >= 0) return true;
    if (url.indexOf('signup') >= 0) return true;
    if (url.indexOf('add-point') >= 0) return true;
    return false;
  }

  getUrl(roles: string[]) {
    return this.cmsModule ? '/home' : '/' + this.globalService.subdomain + '/admin/cms/calendar/0/0/1';
  }

  clearTitleHistory() {
    while (this.globalService.title.size() > 0)
      this.globalService.title.pop();
  }

  showTitle() {
    if (this.globalService.screenHeader == null || this.globalService.screenHeader.trim() == '')
      return "";
    return this.globalService.screenHeader.indexOf("ID:") >= 0 ? "" : this.globalService.translateText(this.globalService.screenHeader);
  }

  needsCacheClear(title): boolean {
    if (this.globalService.pageSave == false)
      return false;
    else
      this.globalService.pageSave = false;

    if (title == null || title.trim() == '')
      return false;

    let clearList: string[] = [
      'Service Details',
      'Group Details',
      'Point System',
      'Manage forms',
      'Volunteering Setup Sheets',
      'Volunteering Details',
      'Component',
      'New Registration',
      'Edit Registration',
      'Event Details'
    ];
    return clearList.includes(title.trim(), 0);
  }

  goBack() {

    this.globalService.selectedOption = '';
    this.overlayContainer.getContainerElement().innerHTML = '';
    if (true) {

      // while (this.globalService.title.peek() == '')
      //   this.globalService.title.pop();

      // if (this.router.url.indexOf('/home') >= 0) {
      //   this.clearTitleHistory();
      //   this.globalService.screenHeader = "";
      //   this.isHomeFlag = true;
      //   return;
      // }

      // if (this.globalService.title.size() == 0) {
      //   this.globalService.screenHeader = "";
      //   this.globalService.clearCurCache = true;
      //   this.globalService.isBack = false;
      //   this.router.navigate(['/']);
      //   this.isHomeFlag = true;
      //   return;
      // }

      this.globalService.clearCurCache = this.needsCacheClear(this.globalService.screenHeader);

      this.globalService.memberSearchFirst = '';
      this.globalService.memberSearchLast = '';
      if (this.globalService.title.size() > 0)
        this.globalService.screenHeader = this.globalService.title.pop();
      else
        this.globalService.screenHeader = '';

      // if (this.router.url.indexOf('/login') >= 0 || this.globalService.screenHeader == '') {
      //   this.globalService.isBack = false;
      //   this.router.navigate(['/']);
      //   return;
      // }

      this.globalService.isBack = true;
      if (this.router.url.indexOf('unauthorized') >= 0)
        this._location.back();
      this._location.back();

      // setTimeout(() => {
      //   this.globalService.clearCurCache = true;
      // }, 100);

    } else {
      this.clearTitleHistory();
      this.globalService.screenHeader = "";
      this.router.navigate(['/']);
      setTimeout(() => {
        this.globalService.clearCurCache = true;
      }, 100);
    }
  }

  getTitle() {
    if (this.globalService?.screenHeader == null)
      return "";
    return this.globalService.translateText(this.globalService.screenHeader ?? "");
  }

  hasFeatures() {
    this.authService.autoLogin(1);
    return (
      this.identityService.permissions != null &&
      (this.identityService.permissions.indexOf('Super Admin') >= 0 ||
        this.identityService.permissions.indexOf('Admin') >= 0 ||
        this.identityService.permissions.indexOf('Group Admin') >= 0 ||
        this.identityService.permissions.indexOf('Leader') >= 0 ||
        this.identityService.permissions.indexOf('Task Assignment') >= 0 ||
        this.identityService.permissions.indexOf('Profile Viewer') >= 0 ||
        this.identityService.permissions.indexOf('Profile Editor') >= 0 ||
        this.identityService.permissions.indexOf('Event Organizer') >= 0 ||
        this.identityService.permissions.indexOf('CMS Administrator') >= 0 ||
        this.identityService.permissions.indexOf('Event Viewer') >= 0 ||
        this.identityService.permissions.indexOf('Attendance Viewer') >= 0 ||
        this.identityService.permissions.indexOf('Communication') >= 0 ||
        this.identityService.permissions.indexOf('Event Viewer') >= 0 ||
        this.identityService.permissions.indexOf('Forms Builder') >= 0 ||
        this.identityService.permissions.indexOf('Birthday') >= 0 ||
        this.identityService.permissions.indexOf('Notes Limites Access') >= 0 ||
        this.identityService.permissions.indexOf('Notes Full Access') >= 0 ||
        this.identityService.permissions.indexOf('Membership Requests') >= 0 ||
        this.identityService.permissions.indexOf('Membership Management') >= 0 ||
        this.identityService.permissions.indexOf('Giving') >= 0)
    );
  }

  get showMemberNavDiv(): boolean {
    return !this.globalService.isRTL && this.router.url != '/home' && !this.isHomeFlag;
  }

  isHome(): boolean {
    var Url = this.router.url.toUpperCase().split(this.subdomain.toUpperCase()).join('');
    // if (Url.toUpperCase().indexOf('/ADMIN/CMS/NOTIFICATION/') >= 0) {
    //   this.isHomeFlag = true;
    //   return true;
    // }
    Url = Url.toUpperCase().split('main').join('');
    Url = Url.toUpperCase().split('HOME').join('');
    Url = Url.split('/').join('');
    this.isHomeFlag = Url == '';
    if (Url.trim() == 'ADMINADMIN-SETUP' && this.cmsModule == false) {
      this.isHomeFlag = true;
      return true;
    }
    return (Url == '');
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    this.isMenuCollapsed = true;

    // Safe subscription to router events
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.zone.run(() => {
          this.isHomeFlag = this.isHome();
          // this.globalService.screenHeader = this.globalService.title.peek() || '';
          this.cdr.detectChanges();
        });
      });
    try {
      const tenantData = await this.tenantService.getSimpleTenant();

      this.cmsModule = tenantData.cmsModule;
      this.subdomain = tenantData.subdomain;

      if (tenantData.deleted === true) {
        this.serviceUnavailable = true;
        this.isLoading = false;
        this.router.navigate(['/service-notfound']);
        return;
      }

      this.churchName = tenantData.name;

      this.donationLink = tenantData.donationLink;
      this.logoSource = await this.tenantService.getTenantSmallLogo(this.subdomain);
      this.isDiocese = tenantData.isDiocese;
      this.isStaging = !environment.production;
      this.churchWebsite = tenantData.churchWebsite || '.';

      // Safely update isHomeFlag after async tenant loading
      setTimeout(() => {
        this.isHomeFlag = this.isHome();
        this.cdr.detectChanges(); // prevents ExpressionChangedAfterItHasBeenCheckedError
      });

    } catch (err) {
      console.error('Error loading tenant data', err);
      this.serviceUnavailable = true;
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  onClickedOutside(e: Event) {
    this.isMenuCollapsed = true;
  }

  onClickedInside(e: Event) {
    if (this.globalService.datePicker != null)
      this.globalService.datePicker.close();
    this.globalService.datePicker = null;
  }

  OnLogout() {
    this.identityService.authenticated = false;
    this.identityService.permissions = [];
    this.authService.logout(1);
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    this.router.navigate(['/home']);
  }

  Features() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    this.panels.toggle('system');
  }

  Writer() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/admin/Writer-setup']), timer);
  }

  Usher() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/usher/check-in']), timer);
  }

  Calendar() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/member/select-service/1']), timer);
  }

  MyRegistrations() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/member/select-service/2']), timer);
  }

  ChangeChurch() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(async () => await this.JumpToChangeChurch(), timer);
  }

  async JumpToChangeChurch() {
    this.router.navigate(['main/switch-tenant']);
  }

  isFluid() {
    return window.innerWidth < 960;
  }

  MyDonations() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/my-donations']), timer);
  }

  Groups() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/groups']), timer);
  }

  Login() {
    this.isMenuCollapsed = true;
    this.router.navigate(['/login']);
  }

  Forms() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/forms']), timer);
  }

  MyProfile() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close();
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.isMenuCollapsed = true;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(() => this.router.navigate(['/myprofile']), timer);
  }

  getWebsite() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    //window.open(this.churchWebsite, 'self');
    this.linkHandler.open(this.churchWebsite);
  }

  getDonationLink() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    //window.open(this.donationLink, 'self');
    this.linkHandler.open(this.donationLink);
  }

  setLanguage(language) {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    localStorage.setItem('Language', language);
    this.globalService.currentLanguage = language;
    // this.router.navigate([this.router.url]);
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    window.location.reload();
  }

  goFeatures() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.globalService.selectedOption = "HOME";
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    this.router.navigate(['/home']);
  }
}

